/** 实验对象模型：器材实例。裁掉化学 LabEngine 同名概念里的物质/反应字段，只留位置与状态。 */

export interface Pose {
  x: number;
  y: number;
  rotation?: number;
}

export interface LabObject {
  id: string;
  type: string;
  pose: Pose;
  state: Record<string, unknown>;
}

export function createLabObject(
  id: string,
  type: string,
  pose: Pose,
  state: Record<string, unknown> = {},
): LabObject {
  return { id, type, pose, state: { ...state } };
}
